

import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import AwardForm from "../components/AwardForm";

export default class AwardsStep extends TalentAppStep
{
    static path = '/awards';
    static LastUpdatedMethod = 'lastUpdatedAwards';
    static HasRequirements = true;
    /**
     * The title shown on the form
     */
    static StepTitle = TB.trans('talent.awards.step_title');
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = TB.trans('talent.awards.step_subtitle');
    /**
     * The start page info tile
     */
    static StepInfo = TB.trans('talent.awards.step_info');
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Resume';
    /**
     * Hide completion icon on sidebar
     */
    static NeedsCompletion = () => false;

    static hasCompleted(user) {
        // let items = TB.filter(user.awards || [], item => item?.name)
        //
        // return items.length > 0;
        return true
    }
    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        if(!this.hasCompleted(user)) return false;
        return `${user.awards?.length} Awards`;
    };

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        return user.validateAwards()
    };

    /**
     * Render the form
     *
     * @returns {Form}
     */
    renderFormFooter() {
        return (
            <div className="pb-6">

                {this.renderChildForm({
                    displayName: TB.trans('talent.awards.award_form_display_name'),
                    ChildFormComponent: AwardForm,
                    userProp: 'awards'
                })}
            </div>
        );
    }

    /**
     * Are requirements optional?
     *
     * @returns boolean
     */
    isRequirementOptional() {
        return true;
    }

    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return 'Awards are optional and not required.';
    }
}